import MobileDetect from 'mobile-detect'
import { useMediaQuery } from 'react-responsive'
import { GRID_BREAKPOINT_MD, GRID_BREAKPOINT_SM } from 'shared/breakpoints'

export const isMobile = () => useMediaQuery({ query: `(max-width: ${GRID_BREAKPOINT_SM}px)` })
export const isTablet = () => useMediaQuery({ query: `(max-width: ${GRID_BREAKPOINT_MD}px)` })
export const isDesktop = () => useMediaQuery({ query: `(min-width: ${GRID_BREAKPOINT_MD}px)` })

export const isMobileAgent = () => {
    const mobileDetect = new MobileDetect(window.navigator.userAgent)

    return !!mobileDetect.mobile()
}

export default isMobile
